import src from "IMAGE";
export default { src, width: 535, height: 777, blurWidth: 0, blurHeight: 0};
